import { render, staticRenderFns } from "./connect_customerService.vue?vue&type=template&id=35516c26&scoped=true"
import script from "./connect_customerService.vue?vue&type=script&lang=js"
export * from "./connect_customerService.vue?vue&type=script&lang=js"
import style0 from "./connect_customerService.vue?vue&type=style&index=0&id=35516c26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35516c26",
  null
  
)

export default component.exports